export default {"src":"/_next/static/media/groundmeat.4203f57e.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};